export const CLEAN_SIGNALS = 'CLEAN_SIGNALS';
export const ADD_SIGNALS = 'ADD_SIGNALS';
export const TOGGLE_SIGNALS = 'TOGGLE_SIGNALS';

export interface sendSignalsActionType {
  type: typeof ADD_SIGNALS;
  signalsValuesPool: createSignalPayload;
}
export interface cleanSignalsActionType {
  type: typeof CLEAN_SIGNALS;
  signalsToDrop: signalsPayload;
}
export interface toggleSignalsActionType {
  type: typeof TOGGLE_SIGNALS;
  signalsToToggle: signalsPayload;
}
export type signalsActionTypes =
  | sendSignalsActionType
  | cleanSignalsActionType
  | toggleSignalsActionType;

export type signalsPayload = { [key: string]: string[] };

export type createSignalPayload = {
  [key: string]: {
    [innerKey: string]: boolean;
  };
};
